import * as Types from '../../types/gql';

export type WithdrawConfirmationEmailVariables = Types.Exact<{ [key: string]: never }>;

export type WithdrawConfirmationEmail = {
  currentUser?: Types.Maybe<{ id: string; userInfo?: Types.Maybe<{ email: string }> }>;
};
